angular.module('leanlaw').factory('invoiceFilterService', ['$state', function ($state) {
  const _state = {
    loading: false,
    cm: {},
    range: {},
    filter: {
      customFields: {},
      // { fieldId: optionId }
      customFieldMeta: {} // { fieldId: { entity: 'client' | 'matter', name: string } }
    },
    expenseRange: null,
    includeNonBillable: true,
    includeContingency: false,
    delivery: null
  };
  function parentState() {
    const parts = $state.current.name.split('.');
    return `${parts[0]}.${parts[1]}`;
  }
  function stateChanged() {
    if ($state.current.name === parentState()) {
      filterChanged();
    }
  }
  function filterChanged() {
    const parent = parentState();
    if (parent === 'billing.review' || parent === 'billing.distribution' || parent === 'billing.distributionPayments' || parent === 'billing.invoiceEmail' || parent === 'billing.invoiceEmailActivity' || parent === 'billing.invoiceInsights' || parent === 'billing.upgradePlan') return;
    const matterOnly = parent === 'billing.payment';
    if (parent !== 'billing.invoice' && (_state.cm.client && !matterOnly || _state.cm.matter)) {
      $state.go(`${parent}.matter`, {
        clientId: _state.cm.client ? _state.cm.client.id : null,
        matterId: _state.cm.matter ? _state.cm.matter.id : null
      });
      return;
    }
    $state.go(`${parent}.summary`, {
      clientId: null,
      matterId: null
    });
  }
  function filterQueryFactory(expenses) {
    return function () {
      const query = {
        billable: 'any',
        //_state.filter.status == 'All' ? 'any' : _state.filter.status == 'Billable',
        billingType: _state.filter.billingType || (_state.includeContingency ? 'contingency' : '-internal,-contingency')
      };
      const range = expenses && _state.expenseRange ? _state.expenseRange : _state.range;
      if (range.startDate) {
        query.startDate = dateToQuery(range.startDate);
      }
      if (range.endDate) {
        query.endDate = dateToQuery(new Date(range.endDate.getTime() + (expenses ? 0 : 60000 * 24 * 60)));
      }
      if (_state.filter.scope) {
        query.scope = _state.filter.scope;
      }
      if (_state.filter.scopeAccount) {
        query.scopeAccount = _state.filter.scopeAccount.id;
      }
      if (_state.filter.matterTag) {
        query.matterTag = _state.filter.matterTag;
      }
      if (_state.cm && _state.cm.client) {
        query.clientId = _state.cm.client.id;
      }
      if (_state.cm && _state.cm.matter) {
        query.matterId = _state.cm.matter.id;
      }
      query.zeros = false;
      if (!_state.includeNonBillable && !_state.includeContingency) {
        query.zerosKey = 'billable';
      }
      return query;
    };
  }
  function reload(state) {
    // Added this because the $watch() on the filter objects were firing too much
    // it would be nice to get rid of this
    const ready = _state && !_state.loading;
    const equals = state && (!state.cm.client && !_state.cm.client || state.cm.client && _state.cm.client && state.cm.client.id == _state.cm.client.id) && (!state.cm.matter && !_state.cm.matter || state.cm.matter && _state.cm.matter && state.cm.matter.id == _state.cm.matter.id) && rangeEqual(state.range, _state.range) && (!_state.expenseRange && state.expenseRange || rangeEqual(state.expenseRange, _state.expenseRange)) && (!state.filter.scopeAccount && !_state.filter.scopeAccount || state.filter.scopeAccount && _state.filter.scopeAccount && state.filter.scopeAccount.id && _state.filter.scopeAccount.id) && state.filter.billingType == _state.filter.billingType && state.filter.matterTag == _state.filter.matterTag && state.includeNonBillable == _state.includeNonBillable && state.includeContingency == _state.includeContingency;
    return ready && !equals;
  }
  function customFieldsEqual(cf1, cf2) {
    if (!cf1 && !cf2) return true;
    if (!cf1 || !cf2) return false;
    const keys1 = Object.keys(cf1 || {});
    const keys2 = Object.keys(cf2 || {});
    if (keys1.length !== keys2.length) return false;
    return keys1.every(key => cf1[key] === cf2[key]);
  }
  function rangeEqual(range1, range2) {
    return !range1 && !range2 || range1 && range2 && range1.startDate == range2.startDate && range1.endDate == range2.endDate;
  }
  function dateToQuery(date) {
    if (!date) return null;
    return date.toNetworkDate();
  }
  function currentMatters() {
    if (_state.cm.matter) {
      return [_state.cm.matter];
    }
    if (_state.cm.client) {
      return _state.cm.client.matters;
    }
    return [];
  }
  return {
    state: _state,
    filterQuery: filterQueryFactory(false),
    expenseFilterQuery: filterQueryFactory(true),
    matters: currentMatters,
    reload,
    filterChanged,
    stateChanged
  };
}]);